/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Paper, PaperProps } from '@mui/material';

export const Page: React.FC<PaperProps> = ({ children, ...props }) => (
  <Paper
    elevation={0}
    {...props}
    sx={{
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100%',
      height: 'fit-content',
      backgroundColor: '#F2F4F5',
      borderRadius: '0px',
      p: '24px',
      pt: '20px',
      position: 'relative',
      ...props.sx,
    }}
  >
    {children}
  </Paper>
);
